import { __decorate } from "tslib";
import { provide } from '@/inversify.config';
export const SpaceHeaderAndLeftServiceSymbol = Symbol.for('SpaceHeaderAndLeftService');
let SpaceHeaderAndLeftService = class SpaceHeaderAndLeftService {
    constructor() {
        // 控制左侧hover蓝条显示
        this.onTouchCollapsed = false;
    }
    changeTouchCollapsedStatus(status) {
        this.onTouchCollapsed = status;
    }
};
SpaceHeaderAndLeftService = __decorate([
    provide(SpaceHeaderAndLeftServiceSymbol)
], SpaceHeaderAndLeftService);
export { SpaceHeaderAndLeftService };
